// extracted by mini-css-extract-plugin
export default {"BooleanFeature":"wk_a bic_b"};